import React, { Component } from 'react';
import impstyles from '../styles/SearchStyles.module.scss';
import Context from '../context/Context';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import SearchResultItem from './searchResultItem';

class SearchResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedID: null,
      loading: false,
      errorMsg: null,
      open: true,
      savedSearchInputDialogOpen: false,
      savedSearchConfirmOpen: false
    };
  }
  currentResults = [];

  preSelectFirstResult() {
    if (
      this.currentResults !== this.context.searchResult &&
      this.context.searchResult !== null &&
      this.context.searchResult.length > 0
    ) {
      this.currentResults = this.context.searchResult;
      const isNonVariantMode = this.context.searchResult[0]?.wpidNbr != null;

      if (isNonVariantMode) {
        this.handleClick('', this.context.searchResult[0]);
        this.setState({ open: true });
      } else {
        if (this.currentResults.includes(this.context.selectedItem)) {
          this.handleClick('', this.context.selectedItem);
        } else {
          this.handleClick('', this.context.searchResult[0]);
        }
        this.setState({ open: true });
      }
    }
  }

  handleClick = (event, row) => {
    this.setState({ selectedID: row['itemNbr'] });
    this.context.selectItemCallback(row);
    return true;
  };

  renderWpidResults(context) {
    const total = context.searchResult.length;
    return (
      <div className={impstyles.collapseResult}>
        <div className={impstyles.searchResultsHeader}>
          <div className={impstyles.topLine} />
          <span className={impstyles.resultsTitle}>
            {total} {total === 1 ? 'Result' : 'Results'}
          </span>
        </div>
        <List component="div" className={impstyles.searchList} disablePadding>
          {context.searchResult.map(row => (
            <SearchResultItem
              key={row.itemNbr}
              item={row}
              selectedID={this.state.selectedID}
              handleClick={this.handleClick}
            />
          ))}
        </List>
      </div>
    );
  }

  render() {
    this.preSelectFirstResult();
    return (
      <Context.Consumer>
        {context => (
          <div className={impstyles.CardOutline}>
            {context.searchResult !== null ? (
              (() => {
                const isNonVariantMode = context.searchResult?.[0]?.wpidNbr != null;
                return isNonVariantMode
                  ? this.renderWpidResults(context)
                  : (
                    <div className={impstyles.collapseResult}>
                      <div className={impstyles.searchResultsHeader}>
                        <div className={impstyles.topLine} />
                        <span className={impstyles.resultsTitle}>
                          {context.searchResult.length} {context.searchResult.length === 1 ? 'Result' : 'Results'}
                        </span>
                      </div>
                      <List
                        component="div"
                        className={impstyles.searchList}
                        disablePadding
                      >
                        {context.searchResult.map(row => (
                          <SearchResultItem item={row} selectedID={this.state.selectedID} handleClick={this.handleClick} key={row.itemNbr} />
                        ))}{' '}
                      </List>{' '}
                    </div>
                  );
              })()
            ) : (
              <Collapse
                className={impstyles.collapseNoResult}
                in={this.state.open}
                timeout="auto"
                unmountOnExit
              >
                <span>No results</span>
              </Collapse>
            )}{' '}
          </div>
        )}
      </Context.Consumer>
    );
  }
}

SearchResult.contextType = Context;
export default SearchResult;
